var map = {
	"./development/insurers.json": [
		7235,
		7235
	],
	"./development/languages.json": [
		98592,
		8592
	],
	"./development/tenant.json": [
		29891,
		9891
	],
	"./local/insurers.json": [
		2860,
		2860
	],
	"./local/languages.json": [
		85338,
		5338
	],
	"./local/tenant.json": [
		30478,
		478
	],
	"./production/insurers.json": [
		28680,
		8680
	],
	"./production/languages.json": [
		91366,
		1366
	],
	"./production/tenant.json": [
		17020,
		7020
	],
	"./staging/insurers.json": [
		56892,
		6892
	],
	"./staging/languages.json": [
		9164,
		9164
	],
	"./staging/tenant.json": [
		40420,
		420
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 47979;
module.exports = webpackAsyncContext;